import React from 'react';
import { useTranslation } from 'react-i18next';
import './Events.css';
import cakesImage from '../assets/images/cakes-bakes.jpg';

interface Event {
  id: number;
  title: string;
  date: string;
  time: string;
  location: string;
  description: string;
  imageUrl: string;
}

const Events: React.FC = () => {
  const { t } = useTranslation();
  const events: Event[] = [
    {
      id: 1,
      title: "Eco-Friendly Bake Sale",
      date: "July 5, 2025",
      time: "2:00 PM",
      location: "Crouch End",
      description: "Join us for a delicious bake sale in aid of green good causes. We only use free-range eggs and, where possible, local ingredients. Gluten-free, nut-free and egg-free options will be available. The Grow-to-be-Green team love to bake and our treats will be on sale to raise money for eco-friendly charities such as: WWF, Greenpeace, and Friends of the Earth.",
      imageUrl: cakesImage
    }
  ];

  return (
    <div className="events-container">
      <h1>{t('events.title')}</h1>
      <div className="events-grid">
        {events.map((event) => (
          <div key={event.id} className="event-card">
            <div className="event-image">
              <img src={event.imageUrl} alt={event.title} />
            </div>
            <h2>{event.title}</h2>
            <div className="event-details">
              <p><strong>Date:</strong> {event.date}</p>
              <p><strong>Time:</strong> {event.time}</p>
              <p><strong>Location:</strong> {event.location}</p>
              <p className="event-description">{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events; 